import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  root: {
  },
  rootWithItems: {
    backgroundColor: 'rgba(0, 0, 0, 0.18)',
    borderRadius: 10,
  },
  rootExpand: {
    paddingLeft: 40,
  },
  rootSelected: {
    backgroundColor: `${theme.palette.primary.contrastText} !important`,
    boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    borderRadius: 5,
  },
  text: {
    color: theme.palette.primary.contrastText,
  },
  textWithout: {
    fontSize: 5,
  },
  textSelected: {
    color: theme.palette.primary.main,
  },
  icon: {
    color: theme.palette.primary.contrastText,
  },
  divider: {
    marginTop: 5,
    marginBottom: 5,
    backgroundColor: 'rgba(255, 255, 255, 0.28)',
  },
}));

